// Layout presets for 1080×1920 (Instagram Reels). Positions keep clear of the
// Reels UI: top bar (~0–150), right action rail (x > ~950, y 1000–1750) and
// the bottom caption/music block (y > ~1620).
export const LAYOUTS = [
  {
    id: "classic",
    name: "Classic dials",
    description: "Tach and speedo side by side up top",
    gauges: {
      tachometer: { x: 28, y: 180, width: 512, height: 512 },
      speedometer: { x: 540, y: 180, width: 512, height: 512 },
    },
  },
  {
    id: "text-side",
    name: "Minimal text",
    description: "RPM, speed and boost as text, tucked to the left",
    gauges: {
      "rpm-text": { x: 48, y: 690, width: 460, height: 170 },
      "speed-text": { x: 48, y: 880, width: 460, height: 170 },
      "boost-text": { x: 48, y: 1070, width: 460, height: 170 },
    },
  },
  {
    id: "race",
    name: "Race",
    description: "Big center tach, gear and speed below",
    gauges: {
      tachometer: { x: 190, y: 160, width: 700, height: 700 },
      gear: { x: 690, y: 1085, width: 200, height: 240 },
      "speed-text": { x: 60, y: 1120, width: 460, height: 170 },
    },
  },
  {
    id: "boosted",
    name: "Boosted",
    description: "Tach and boost dials with gear and speed",
    gauges: {
      tachometer: { x: 28, y: 180, width: 512, height: 512 },
      boost: { x: 540, y: 180, width: 512, height: 512 },
      gear: { x: 690, y: 1060, width: 200, height: 240 },
      "speed-text": { x: 60, y: 1100, width: 460, height: 170 },
    },
  },
];
